export const getCountryCodes = query => ({
  type: 'GET_COUNTRY_CODES',
});

export const countryCodesReceived = data => ({
  type: 'SET_COUNTRY_CODE',
  data,
});

export const checkInviteStatus = query => ({
  type: 'INVITE_STATUS',
  query,
});

export const inviteStatusChecked = data => ({
  type: 'INVITE_STATUS_CHECKED',
  data,
});

export const multiprofiles = data => ({
  type: 'MULTI_PROFILE',
  data,
});

export const sendSignupInfo = payload => ({
  type: 'POST_SIGNUP',
  payload,
  loader: true,
});

export const signupSuccess = data => ({
  type: 'SIGNUP_SUCCESS',
  data,
});

export const fetchauthmode = payload => ({
  type: 'GET_FETCH_MODE',
  payload,
});

export const setauthmode = data => ({
  type: 'SET_FETCH_MODE',
  data,
});

export const loginApi = (payload, authData) => ({
  type: 'POST_LOGIN',
  payload,
  authData,
  loader: true,
});

export const loginSuccess = data => ({
  type: 'LOGIN_SUCCESS',
  data,
});

export const clearStore = data => ({
  type: 'CLEARALL',
  data,
});

export const generateOTP = payload => ({
  type: 'GENERATE_OTP',
  payload,
});

export const _checkSSO = payload => ({
  type: 'CHECK_SSO',
  payload,
});

export const otpSent = data => ({
  type: 'OTP_SENT',
  data,
});

export const resetStateForRecaptcha = () => ({
  type: 'RESET_RECAPTCHA',
});

export const resetWithOTP = () => ({
  type: 'RESET_WITH_OTP',
});

export const resetOTPSent = data => ({
  type: 'RESET_OTP_SENT',
  data,
});

export const mncResetWithOTP = payload => ({
  type: 'MNC_RESET_OTP_SENT',
  payload,
});

export const mncResetOTPSent = data => ({
  type: 'MOBILE_NO_CHANGE_RESET_OTP_SENT',
  data,
});
export const editMobileNo = payload => ({
  type: 'EDIT_MOBILE_NO',
  payload,
});

export const editName = payload => ({
  type: 'EDIT_NAME',
  payload,
  loader: true,
});

export const resetMobileNoSuccess = data => ({
  type: 'RESET_MOBILENO_SUCCESS',
  data,
});

export const nameEditSuccess = data => ({
  type: 'NAME_EDIT_SUCCESS',
  data,
});

export const resetPassword = payload => ({
  type: 'POST_RESET_PASSWORD',
  payload,
});

export const resetPasswordSuccess = data => ({
  type: 'RESET_PASSWORD_SUCCESS',
  data,
});

export const saveLoginData = data => ({
  type: 'SET_LOGIN_DATA',
  data,
});

export const showSnackbar = data => ({
  type: 'SHOW_SNACK_BAR',
  data,
});
export const setLoginErrorData = data => ({
  type: 'SET_LOGIN_ERROR_DATA',
  data,
});
export const sesisonResendOTP = payload => ({
  type: 'SESSION_LOGIN_OTP',
  payload,
});
export const sesisonVerifyOTP = payload => ({
  type: 'SESSION_VERIFY_OTP',
  payload,
  loader: true,
});
